module.exports = __webpack_public_path__ + "static/img/guarantee.968a342.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/guarantee.png
// module id = jICI
// module chunks = 1